import script from "./TaxonomyAssignmentManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxonomyAssignmentManager.vue?vue&type=script&setup=true&lang=js"

export default script